//TODO - this may not always work 2 different scopes can be running at the same time
export namespace ExtendImpersonationSessionMap {
  const impersonationScope: Set<ImpersonationScope> = new Set<ImpersonationScope>();

  export function addScope(scope: ImpersonationScope): void {
    impersonationScope.add(scope);
  }

  export function isScopeActive(): boolean {
    return impersonationScope.size > 0;
  }

  export function removeScope(scope: ImpersonationScope): void {
    impersonationScope.delete(scope);
  }
}
//if you want your scope to fall under extend imepersonation session add the respective enum
//ngOnInit => ExtendImpersonationSessionMap.addScope(ImpersonationScope.YOUR_SCOPE)
//ngOnDestroy => ExtendImpersonationSessionMap.removeScope(ImpersonationScope.YOUR_SCOPE)
export enum ImpersonationScope {
  CHECKOUT = 'CHECKOUT',
}
